module.exports = __webpack_public_path__ + "static/img/240_TO8_2174.40c0add.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/240_TO8_2174.jpg
// module id = /lue
// module chunks = 0